export default __webpack_public_path__ + "static/media/icon-coin-aero.875e8a4d.svg";